const downgradeStepsEnum = {
  LOST_FEATURES: 0,
  REASONS: 1,
  SALE_OFFER: 2,
  SUBSCRIPTION_PAUSE: 3,
  TEAM: 4,
  UNLIMITED: 5,
  OFFERS_1: 6,
  OFFERS_2: 7,
  FINAL: 8,
};

export const signUpSteps = [
  {
    id: downgradeStepsEnum.EMAIL,
    label: 'Email',
  },
  {
    id: downgradeStepsEnum.VALIDATE_EMAIL,
    label: 'Validate Email',
  },
  {
    id: downgradeStepsEnum.PASSWORD,
    label: 'Password',
  },
  {
    id: downgradeStepsEnum.PROFILE,
    label: 'Profile',
  },
  {
    id: downgradeStepsEnum.TEAM,
    label: 'Team',
  },
  {
    id: downgradeStepsEnum.BRANDING,
    label: 'Branding',
  },
];

export { downgradeStepsEnum };
